import React from 'react'
import ApiProfile from '../code/api/ApiProfile';
import Customer from '../code/models/Customer';
import Profile from '../code/models/Profile';
import { stringToDate } from '../code/helpers/stringToDate';
import CclDataTable, { CclDataTableButtonType, CclDataTableColumnType, CclDataTableColumnDef } from './CclDataTable';
import ApiBidding from "../code/api/ApiBidding";
import Toaster from "./Toaster";
import '../css/customerinfoprofiles.css';

interface ICustomerInfoProfiles {
  customerId: number;
}

export default function CustomerInfoProfiles({ customerId }: ICustomerInfoProfiles) {
  const [toastMessage, setToastMessage] = React.useState<string>("");
  const [profiles, setProfiles] = React.useState<Profile[] | null>(null);

  React.useEffect(() => {
    loadProfiles();
  }, []);

  async function loadProfiles() {
    ApiProfile.getProfiles(customerId).then(data => {
      setProfiles(data);
    });
  }

  function formatDate(val: any, dataRow: any): string {
    return `${stringToDate(val + "")}`;
  }

  function formatDeleteCheck(val: any, dataRow: any) {
    return (
      <input type="checkbox" checked={val} onChange={(e) => changeDeleted(e, dataRow)} />
    )
  }

  function changeDeleted(e: any, profile: Profile): void {
    var action: Promise<boolean>;

    if (profile.isDeleted) {
      action = ApiProfile.undeleteProfile(profile.profileId);
    } else {
      action = ApiProfile.deleteProfile(profile.profileId);
    }
    action.then((success) => {
      if (success) {
        profile.isDeleted = !profile.isDeleted;
        e.target.checked = profile.isDeleted;
      }
    });
  }

  const profileColumnDefs: CclDataTableColumnDef[] = [
    {
      fieldName: "id",
      title: "id",
      visible: false,
      type: CclDataTableColumnType.Data
    }, {
      fieldName: "name",
      title: "Name",
      visible: true,
      type: CclDataTableColumnType.Data,
      className: "customer-profile-name-cell"
    }, {
      fieldName: "bidType",
      title: "Bid Type",
      visible: true,
      type: CclDataTableColumnType.Data
    }, {
      fieldName: "isDeleted",
      title: "Deleted",
      visible: true,
      type: CclDataTableColumnType.Data,
      className: "customer-profile-check-cell",
      formatData: formatDeleteCheck
    }, {
      fieldName: "updated",
      title: "Updated",
      visible: true,
      type: CclDataTableColumnType.Data,
      formatData: formatDate
    }, {
      fieldName: "updated",
      title: "Bid Plan",
      visible: true,
      type: CclDataTableColumnType.Button,
      buttonClassName: "btn btn-outline-primary btn-sm",
      buttonName: "bidPlanButton",
      buttonText: "Create Plan",
      buttonType: CclDataTableButtonType.Confirm,
      buttonConfirmTitle: "Bid Plan",
      buttonConfirmText: "Create bid plan for profile?",
      formatData: formatDate
    }
  ];

  function handleOnButtonClick(rowData: Profile, buttonName: string) {
    if (buttonName !== "bidPlanButton") return;
    ApiBidding.createBidPlan(rowData.profileId).then((result) => {
      setToastMessage(`Bid plan created for plan "${rowData.name}".`)
    });
  }

  return (
    <React.Fragment>
      <div className='customer-profile-table-wrapper'>
        <CclDataTable
          name={"profilesTable"}
          tableData={profiles || []}
          columnDefinitions={profileColumnDefs}
          rowSelect={false}
          onRowSelect={null}
          onButtonClick={handleOnButtonClick} />
      </div>
      <Toaster title="Profiles" subtitle="info" message={toastMessage} key={"custInfdetailtoast"} />
    </React.Fragment>
  )
}
